















import Vue, { PropType } from 'vue';

import { DynamicDocumentItem, DynamicDocumentItemData } from '@/types';
import documentCtxMixin from '../document-ctx';

export default documentCtxMixin.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    data: Object as PropType<DynamicDocumentItemData>,
  },

  data() {
    return {
      value: '',
    };
  },

  mounted() {
    this.value = this.data.value as string;
  },

  methods: {
    scrollTo() {
      if (!this.$refs.textarea) return;

      const ta: Vue = this.$refs.textarea as Vue;

      setTimeout(() => this.$scrollTo(ta.$el, 100, { offset: -150 }), 100);
    },
  },
});
